<template>
  <div class="app">
    <div :style="{ top: 0, width: '100%', height: SafeTop + 'px' }" class="safezone-coverUp"></div>
    <main :class="{ flex: true, col: true, h100: true }">
      <transition name="fade">
        <router-view></router-view>
      </transition>
    </main>
    <div :style="{ bottom: 0, width: '100%', height: SafeBottom + 'px' }" class="safezone-coverDown"></div>
    <transition name="fade">
      <Loading :loadingValue="loadingValue" v-if="loading" />
    </transition>
    <!-- <AddToHomeScreen v-if="!loading" /> -->
    <Popup v-if="!loading" />
    <!-- <ErrorMessage v-if="showError" /> -->
  </div>
</template>

<script>
import "./app.scss";
import "../static/css/whatsapp.css";
import { authService } from "./services/authService";
import { userService } from "./services/userService";
import { App as Native } from "@capacitor/app";
import { SafeArea } from "capacitor-plugin-safe-area";
import axios from "axios";

import Popup from "./components/Popup/popup.vue";
import ErrorMessage from "./components/Shared/ErrorMessage.vue";
import Loading from "./components/Shared/Loading.vue"

export default {
  data() {
    return {
      sideNav: false,
      height: "",
      user: null,
      gotNext: false,
      SafeTop: 0,
      SafeBottom: 0,
      timeoutRef: null,
      showError: false,
      loading: true,
      loadingValue: 0,
    };
  },
  components: { Popup, ErrorMessage, Loading },
  async created() {
    this.generateWhatsapp()
    
    // Handle OAuth callback first (check for tokens in URL)
    console.log("App: Checking for OAuth callback tokens in URL");
    console.log("App: Current URL:", window.location.href);
    const authCallback = authService.handleAuthCallback();
    if (authCallback.success) {
      console.log("App: Successfully handled OAuth callback with tokens");
      console.log("App: Tokens processed, checking localStorage...");
      console.log("App: localStorage engrefresh exists:", !!localStorage.getItem("engrefresh"));
    } else if (authCallback.error) {
      console.error("App: OAuth callback error:", authCallback.error);
    } else {
      console.log("App: No OAuth tokens found in URL");
    }
    
    // Check authentication state
    const authState = await authService.checkAuthState();
    console.log("App: Authentication state:", authState);
    
    // Skip CSRF token check for now since JWT auth is working
    console.log("App: Skipping CSRF token check (using JWT authentication)");
    this.loadingValue = 20,

    Native.addListener("backButton", data => {
      if (this.$route.name == "chapter") {
        Native.minimizeApp();
      } else {
        this.$router.push({path: "/chapter", query: this.$route.query});
      }
    });
    if (this.$route.name == "payment") this.loading = false;
    if (this.$route.name == "paymentId") this.loading = false;
    
    this.loadingValue = 50,
    
    // Load user data - this will set the user in the store if authenticated
    console.log("App: Loading user data...");
    console.log("App: Current axios Authorization header:", axios.defaults.headers.common["Authorization"]);
    this.user = await userService.getUser();
    console.log("App: User loaded:", this.user);
    console.log("App: Store user state:", this.$store.getters.user);
    console.log("App: Store isLogged state:", this.$store.getters.isLogged);
    
    // Initialize store with user data
    this.$store.dispatch({ type: "initData", user: this.user });
    
    this.loadingValue = 90;
    this.loading = false;
  },
  computed: {
    course() {
      return this.$store.getters.course;
    },
    error() {
      return this.$store.getters.error;
    },
  },
  mounted() {
    if (this.timeoutRef) {
      clearTimeout(this.timeoutRef);
    }
    SafeArea.getSafeAreaInsets().then(({ insets }) => {
      // console.log(insets);
      if (Capacitor.getPlatform() === "ios") {
        this.SafeTop = insets.top;
        this.SafeBottom = insets.bottom;
      } else {
        this.SafeTop = 0;
        this.SafeBottom = 0;
      }
    });
    // Set loading to false when both user and course are loaded
    this.$watch(
      () =>
        this.user &&
        Object.keys(this.user).length &&
        this.course &&
        Object.keys(this.course).length,
      newVal => {
        if (newVal) {
          this.loading = false;
        }
      }
    );
  },
  watch: {
    error(newVal, oldVal) {
      if (newVal) {
        this.showError = true
      } else {
        console.log("Nothing to do here.");
      }
    },
    SafeTop() {
      this.$store.commit("setSafeTop", this.SafeTop);
    },
    SafeBottom() {
      this.$store.commit("setSafeBottom", this.SafeBottom);
    },
    async user() {
      this.checkCondition()
    },
    async course() {
      this.checkCondition()
    }
  },
  methods: {
    setHeight(height) {
      this.height = height;
    },
    async checkCondition() {
      if (
        this.$route.name === "chapter" ||
        this.$route.name === "home" ||
        this.$route.name === "chapter-check" ||
        this.$route.name === "index" ||
        this.$route.name === "welcome"
      ) {
        if (this.user && Object.keys(this.user).length && this.course && Object.keys(this.course).length && !this.gotNext) {
          const nextLesson = await userService.nextLesson(this.user);
          this.$store.commit("setNextLesson", nextLesson);
          this.gotNext = true;
          const chap =
            this.course.findIndex(res => res.id == nextLesson.chapter) + 1;
          if (chap) this.$router.push({path: `/chapter/${chap}`, query: this.$route.query});
          else this.$router.push({path: "/chapter/1", query: this.$route.query});
        }
      }
    },
    generateWhatsapp() {
      var config = {
        whatsapp: "972526252650",
        call_to_action: this.$t("whatsappButton.call"),
        position: localStorage.getItem("srcDirection") == "rtl" ? "ww-left" : "ww-right",
        size: "30",
        text: this.$t("whatsappButton.text"),
        type: "ww-standard",
        brand: "",
        subtitle: "",
        welcome: "",
        shiftVertical: "150",
      };
      var proto = document.location.protocol,
          host = "getbutton.io",
          url = proto + "//static." + host;
      var s = document.createElement('script');
      s.type = 'text/javascript';
      s.async = true;
      s.src = url + '/widget-send-button/js/init.js';
      s.onload = function () { WhWidgetSendButton.init(host, proto, config); };

      var x = document.getElementsByTagName('script')[0];
      x.parentNode.insertBefore(s, x);
    }
  }
};
</script>



// WEBPACK FOOTER //
// App.vue?464d4910